import React, { useEffect, useState } from "react";
import SuccessImage from "../assets/undraw_winners_ao2o1.svg";
import GoogleImage from "../assets/google-button.svg";
import AppleImage from "../assets/apple_store.png";
import { useHistory } from "react-router-dom";

export default function Success({ navigation }) {
  const [accountNumber, setAccountNumber] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [AccountName, setAccountName] = useState("");
  const { go } = navigation;

  const closeApp = () => {
    window.location.href = "/accountOpening";
    // go("bvn");
    // window.close();
  };
  useEffect(() => {
    let data = JSON.parse(sessionStorage.getItem("res"));

    setAccountNumber(data.account);
    setCustomerNumber(data.customer_number);
    setAccountName(
       data.first_name + " " + data.mid_name + " " + data.last_name
    );
  }, []);

  return (
    <div className="row">
      <div className="col-md-10 offset-md-1">
        <div className="header d-flex justify-content-between">
          <div>
            <h1 className="font-weight-bold">All Done!</h1>
            <h4 className="text-warning">Welcome back.</h4>
          </div>
          <div>
            <img src={SuccessImage} alt="" width="300" />
          </div>
        </div>

        <div className="infocard p-5 mb-5">
          <p>
            CONGRATULATIONS! {AccountName}
            <br />
            Your <b className="text-warning">ProvidusBank</b> account has been
            updated. <br />
            
          </p>

          <p>
            Kindly click{" "}
            <a
              className="text-warning"
              target="_blank"
              href="https://bankonline.providusbank.com/account/register"
              style={{ textDecoration: "none" }}
            >
              HERE
            </a>{" "}
            to Register on our internet banking platform.
          </p>
          {/* to proceed to view your account on our internet banking platform */}
          <p>Please copy your "Customer ID" to activate your online profile.</p>
          <p>
            You can also download our mobile app “ProvidusPlus” from the
            Playstore for{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.providus.providusbank"
              target="_blank"
              className="text-warning"
              style={{ marginRight: "2px", textDecoration: "none" }}
            >
              Android
            </a>
            {/* https://play.google.com/store/apps/details?id=com.providus.providusbank */}
            or App store for
            <a
              href="https://apps.apple.com/us/app/providusplus/id1566859972"
              target="_blank"
              className="text-warning"
              style={{ marginLeft: "2px", textDecoration: "none" }}
            >
              IOS
            </a>
            .
          </p>
          <div className="row">
            <div className="col-md-6">
              <a
                href="https://play.google.com/store/apps/details?id=com.providus.providusbank"
                target="_blank"
              >
                <img src={GoogleImage} alt="" width="200" />
              </a>
            </div>
            <div className="col-md-6">
              <a
                href="https://apps.apple.com/us/app/providusplus/id1566859972"
                target="_blank"
              >
                <img src={AppleImage} alt="" width="200" />
              </a>
            </div>
          </div>
          <div className="next">
            <br /> <br />
            <p>
              Click
              <button onClick={() => closeApp()}>here</button>
              to return
            </p>
            <br />
            <span className="lead text-warning">
              You can find out more information at{" "}
              <a className="text-warning" href="https://www.providusbank.com/">
                https://www.providusbank.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
